import { createAction, props } from "@ngrx/store";
import { SignedInUser, User } from "../../schemas/user";

export const addUser = createAction(
  '[User] Added',
  props<{ payload: User }>()
);
